// extracted by mini-css-extract-plugin
export var container = "styles-module__container___MD2du";
export var rightsReserved = "styles-module__rightsReserved___yTPTJ";
export var links = "styles-module__links___MBVVB";
export var text = "styles-module__text___0hm7w";